import forge from 'node-forge';
export function decryptPrivateKey(encryptedKey, password, salt) {
    const aesKey = forge.pkcs5.pbkdf2(password, salt, 4096, 32, forge.md.sha512.create());
    const decipher = forge.cipher.createDecipher('AES-CBC', aesKey);
    decipher.start({ iv: salt });
    const decodedKey = forge.util.decode64(encryptedKey);
    decipher.update(new forge.util.ByteStringBuffer(decodedKey));
    if (!decipher.finish()) {
        throw new Error('Decrypting private key failed');
    }
    const decryptedKey = decipher.output.data;
    return decryptedKey;
}
export function encryptPrivateKey(key, password, salt) {
    const aesKey = forge.pkcs5.pbkdf2(password, salt, 4096, 32, forge.md.sha512.create());
    const cipher = forge.cipher.createCipher('AES-CBC', aesKey);
    cipher.start({ iv: salt });
    cipher.update(new forge.util.ByteStringBuffer(key));
    cipher.finish();
    const encryptedKey = cipher.output.data;
    const base64EncryptedKey = forge.util.encode64(encryptedKey);
    return base64EncryptedKey;
}
//# sourceMappingURL=key-utils.js.map